// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Unibrow-cls1___93d90598c109a1f24b6{/*!*/}.Unibrow-cls2___eea3f26ff72849431ff{background-color:#f2f0ec;background-color:var(--brand-colors-beige-200, #f2f0ec);color:#3a372f;color:var(--text-beige-primary, #3a372f)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Unibrow-cls1___93d90598c109a1f24b6",
	"cls2": "Unibrow-cls2___eea3f26ff72849431ff Unibrow-cls1___93d90598c109a1f24b6"
};
export default ___CSS_LOADER_EXPORT___;
